// Keep this versioned URL stable. New terms require a new versioned document.
export const researchLicenseUrl = 'https://workspace369.com/downloads/research/license-v1.html';
export const isResearchLicenseSchema = (node) => node?.['@type'] === 'CreativeWork'
  && node.url === researchLicenseUrl
  && node.version === '1.0'
  && node.inLanguage === 'en'
  && node.name === 'Workspace369 Research Dataset Reuse License'
  && node.publisher?.name === 'Workspace369 LLC';
